<template>
  <ModalWindow @close="closeModal()">
    <div class="bb-modal-delete" @click.stop>
      <transition name="slide-fade">
        <span v-if="!deleteConfirm.stepTwo">Step 1</span>
      </transition>
      <transition name="slide-fade">
        <span v-if="deleteConfirm.stepTwo">Step 2</span>
      </transition>
      <p class="bb-modal-delete__number" v-html="title">
        {{ title }}
      </p>
      <p class="bb-modal-delete__text">
        Please enter {{ password ? 'password' : 'DELETE' }}
        <transition name="bounce">
          <span v-if="deleteConfirm.stepTwo">again</span>
        </transition>
        to confirm deletion
      </p>
      <div class="bb-modal-delete-input-wrapper">
        <input class="bb-input bb-input_border bb-modal-delete-input-wrapper__input"
               v-model="inputText"
               @input="inputError = false"
               :type="passwordFieldType"
               autocomplete="new-password"
               @keyup.enter="checkConfirmDelete()"
               :class="{
                   'bb-modal-delete-input-wrapper__input_error': inputError}"
               v-autofocus/>
        <div class="bb-modal-delete-input-wrapper__icon"
             v-if="password"
             @click="switchVisibility"
        >
          <IconEyes :passwordFieldType="passwordFieldType"/>
        </div>
        <transition name="bounce">
          <span v-if="inputError" class="bb-modal-delete-input-wrapper__error">{{ errorText }}</span>
        </transition>
      </div>
      <button class="bb-modal-delete__button bb-button" @click="checkConfirmDelete()">DELETE</button>
    </div>
  </ModalWindow>
</template>

<script>
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import IconEyes from '@/components/Main/Icons/IconEyes'

export default {
  name: 'DoubleDelete',
  props: ['id', 'title', 'open', 'password'],
  components: {
    IconEyes,
    ModalWindow
  },
  data () {
    return {
      inputText: '',
      inputError: false,
      errorText: 'password is incorrect',
      passwordFieldType: 'password',
      deleteConfirm: {
        item: {},
        stepTwo: false
      }
    }
  },
  computed: {
    confirmWord () {
      return this.password ? this.password : 'DELETE'
    }
  },
  methods: {
    closeModal () {
      this.deleteConfirm.stepTwo = false
      this.$emit('close')
    },
    switchVisibility () {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    checkConfirmDelete () {
      if (this.deleteConfirm.stepTwo && this.inputText === this.confirmWord) {
        this.inputText = ''
        this.inputError = false
        this.$emit('delete', this.id)
        return
      } else {
        this.inputError = true
      }
      if (this.inputText === this.confirmWord) {
        this.deleteConfirm.stepTwo = true
        this.inputError = false
      } else {
        this.inputError = true
      }
      this.inputText = ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bb-modal-delete {
  @include global-font;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 14px;

  &__number {
    margin: 15px auto;
    font-weight: bold;
  }

  &__text {
    margin-bottom: 25px;
  }

  &-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;

    &__icon {
      position: absolute;
      right: 10px;
      top: 7px;
      cursor: pointer;
    }

    &__input {
      &_error {
        animation: shake .3s ease-out;
        border-color: $color-red-orange;
      }
    }

    &__error {
      position: absolute;
      right: 10px;
      color: $color-red-orange;
      font-size: 11px;
      line-height: 13px;
      pointer-events: none;
    }
  }

  &__button {
    margin-top: 25px;
    width: 117px;
    box-sizing: border-box;
    border: 2px solid rgba($color-red-orange, 1);
    position: relative;
    margin-left: 16px;
    color: $color-red-orange;
    background-color: $color-white;

    &:hover {
      border-color: rgba($color-red-orange, 0.65);
    }
  }
}

@keyframes shake {
  from,
  to {
    transform: translate3d(0, 0, 0);
  }

  20%,
  60% {
    transform: translate3d(-3px, 0, 0);
  }

  40%,
  80% {
    transform: translate3d(3px, 0, 0);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/DoubleDelete/DoubleDelete.vue